import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import Dot from '@/components/ui/Dot.tsx';
import { formatDayAndMonth } from '@/features/dashboard/bookingChanges/utils/formatters.ts';
import { formatSignedMoneyList } from '@/features/dashboard/bookingChanges/utils/formatters.ts';
import RecentChangesEntry from './RecentChangesEntry';
import { pluralizeItems } from '@/features/dashboard/bookingChanges/utils/plurals.ts';

interface RecentChangesDraftRowProps {
  draft: ChangeDraftVm;
}

/**
 * Otwarty szkic nad historią — wyróżniony tłem i pustą kropką, bo w
 * przeciwieństwie do paczek pod nim jeszcze nie wszedł w życie.
 *
 * Data zapisu i autor bywają puste (paczka założona bez rozpoznanego
 * pracownika, jeszcze nieedytowana), więc segmenty wypadają zamiast zostawiać
 * pustkę między separatorami.
 */
const RecentChangesDraftRow = ({ draft }: RecentChangesDraftRowProps) => (
  <div className="flex items-start gap-2.5 border-b border-neutral-100 bg-neutral-50 px-5 pb-4 pt-3.5">
    <Dot hollow className="mt-[5px]" />
    <RecentChangesEntry
      title={`Szkic · ${pluralizeItems(draft.itemCount)}, ${formatSignedMoneyList(draft.totalDelta)}`}
      meta={[
        draft.lastSavedAt && formatDayAndMonth(draft.lastSavedAt),
        draft.author,
        'czeka na wprowadzenie',
      ]
        .filter(Boolean)
        .join(' · ')}
    />
  </div>
);

export default RecentChangesDraftRow;
